import { DefaultAPI } from './types'

export const defaultApi: DefaultAPI = ky => {
  return {
    async exist({ endpoint, heartlinePk }) {
      console.log('endpoint', endpoint)
      return await ky(`api/user/heartline/${heartlinePk}/`, {
        prefixUrl: endpoint,
        method: 'get'
      }).json()
    },

    async login({ endpoint, username, password, heartlinePk, accessToken }) {
      return await ky('api/user/heartline/', {
        prefixUrl: endpoint,
        method: 'post',
        json: {
          username,
          password,
          // eslint-disable-next-line @typescript-eslint/camelcase
          heartline_pk: heartlinePk,
          // eslint-disable-next-line @typescript-eslint/camelcase
          access_token: accessToken
        }
      }).json()
    }
  }
}
